import React from "react";
import "./Inputfeild.css";

const InputField = ({ icon, iconPosition = "right", iconClick, className = "", ...props }) => {
  return (
    <div className={`custom-input-wrapper ${icon ? "has-icon" : ""} ${iconPosition}`}>
      {icon && (
        <span className="custom-input-icon" onClick={iconClick}>
          {typeof icon === "string" ? <img src={icon} alt="icon" className="icon-img" /> : icon}
        </span>
      )}
      <input className={`custom-input ${className}`} {...props} />
    </div>
  );
};

export default InputField;
